import axios from '@axios'

export default {
  namespaced: true,

  state: {
    items: [],
  },

  getters: {},

  mutations: {
    ITEMS(state, value) {
      state.items = value
    },
  },

  actions: {
   /* fetchItems(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/author_evaluations', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },*/
    fetchItems({ commit }, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/author_evaluations', { params: queryParams })
          .then(response => {
            // Sauvegarde la liste dans le state Vuex
            const data = response.data.data || response.data
            commit('ITEMS', data)

            resolve(response)
          })
          .catch(error => reject(error))
      })
    },

    fetchItem(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/author_evaluations/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    addItem(ctx, itemData) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: '/author_evaluations',
          data: itemData,
          validateStatus: status => true,
        })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    deleteItem(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/author_evaluations/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
